import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { $checkAdminAccess } from "~/lib/admin/queries";

export const Route = createFileRoute("/(authenticated)/dashboard/admin")({
  beforeLoad: async () => {
    const allowed = await $checkAdminAccess();
    if (!allowed) {
      throw redirect({
        to: "/dashboard/settings",
        search: { adminDenied: "1" },
      });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 p-4 lg:p-6">
      <div>
        <h1 className="text-2xl font-bold">Admin</h1>
        <p className="text-muted-foreground text-sm">
          Internal tools — not visible to other users
        </p>
      </div>
      <Outlet />
    </div>
  );
}
